export default {
    install (Vue) {
        
		Vue.prototype.asset = (resource) => {
			return '/' + resource;
		}
	}
}